import { httpCreate, url } from './http';
import conf from '@/config';

const http = httpCreate(conf.apipath + '/user/');

export const user = {
	getUserInfo(params) {
		return http.get('getUserinfo', { params });
	},
	getActivity(uid, pageNum, pageSize, error) {
		return http.get('getActivity', {
			params: { page: 0 },
		});
	},

	//获取用户支付宝信息
	getAliPayInfo() {
		return http.get('alipayUser');
	},
	getByPhone(params) {
		console.log(params);
		return http.get('getByPhone', { params });
	},

	// 按Id获取用户信息
	getUserInfoById(userId) {
		return http.get(`${userId}/detail`);
	},
	// 编辑用户信息
	EidtUser(uuid, data) {
		return http.post(`edit/${uuid}`, data);
	},
	/**
	 * 登出
	 */
	logout() {
		return http.get('logout');
	},
	// 获取用户详细信息
	getUserInfoAll() {
		return http.get('detail');
	},
	// 编辑当前用户密码
	editPassword(data) {
		return http.post('editPassword', data);
	},
	// 校验旧手机
	verifyOldPhone(data) {
		return http.post('verifyOldPhone', data);
	},
	//发送验证码
	sendCode(data) {
		return http.post('sendMessage', null, { params: data });
	},
	//绑定手机

	binNewPhone(data) {
		return http.post('editMobPhone', data);
	},
	//验证码图片
	getVerify() {
		return http.get('verify');
	},
	//绑定邮箱
	bindEmail(data) {
		return http.post('email', data);
	},
	//微信绑定
	bindWeixin() {
		return http.post('getQRCode');
	},
	// 获取绑定微信二维码
	bindWxQrcode() {
		return http.get('getQRCode');
	},
	//微信解绑
	cancelBindWeixin() {
		return http.post('relieveWechatBind');
	},
	//老的上传头像（暂时保留）
	uploadAvatar(data) {
		return http.post('uploadAvatar', data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	},
	verifyCode() {
		return `${url('/user/verifyCode')}?${Math.random()}`;
	},
	addUser(data) {
		return http.post('addUser', data);
	},
	// 获取用户列表（管理员）
	/**
	 *
	 * @param {Numbwe} pageNum
	 * @param {Numbwe} pageSize
	 * @param {Object} data  {mobPhone, userName}
	 * @param {function} error
	 */
	getUserList(params, data) {
		const ret = http.post('list', data, { params });
		return ret;
	},
	// 重置用户密码
	resetPwd(userId, data) {
		const ret = http.post(`resetPassword/${userId}`, data);
		return ret;
	},
	//获取用户详情
	// getActivity(uid, pageNum, pageSize, error) {
	// 	var ret = http.get(`getActivity/${uid}`, {
	// 		params: { pageNum, pageSize }
	// 	});
	// 	return ret;
	// },
	getAuthorize(uid, pageNum, pageSize, error) {
		var ret = http.get(`getAuthorize/${uid}`, {
			params: { pageNum, pageSize },
		});
		return ret;
	},
	//编辑用户信息
	editUserInfo(data) {
		return http.post('editUserInfo ', data, {
			ssoPath: conf.ssoPath,
		});
	},
};
